import { render, staticRenderFns } from "./ContractsPriceChangeTable.vue?vue&type=template&id=5731d250"
import script from "./ContractsPriceChangeTable.vue?vue&type=script&lang=js"
export * from "./ContractsPriceChangeTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports